import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly title: string;
  readonly description: string;
}

export const CryptoCompletedModal: React.FC<Props> = (props: Props): React.ReactElement => {
  const { title, description } = props;
  const navigate = useNavigate();
  const onClose = React.useCallback((): void => {
    navigate('/home', { replace: true });
  }, [navigate]);
  const tr = useTranslator();

  return (
    <ApplicationModal title={title} description={description} variant="prominent" onClose={onClose}>
      <Button variant="dark" fullWidth={true} onClick={onClose}>
        {tr('DONE')}
      </Button>
    </ApplicationModal>
  );
};
